import { cn } from '@kidshome/ui';

/**
 * The canonical real-money (cash, ₴) glyph — the deck `_icons.js` #i-cash geometry: a banknote outline
 * with a centre coin. The counterpart to {@link CoinIcon} (coins) and the violet ✨ star, completing the
 * three-currency set. Decorative (`aria-hidden`) — the surrounding label/amount carries the meaning.
 *
 * Inherits `currentColor` so the THEME colours it (green on a `text-success` cash surface), and sizes to
 * `1em` to scale with its context. One shape, one source of truth — used wherever cash needs a mark
 * (the guardian wallet card, the child-overview accounts row), distinct from coins and stars.
 */
export function CashIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('inline-block size-[1.15em] shrink-0 align-[-0.15em]', className)}
    >
      <rect x="2.5" y="6" width="19" height="12" rx="2" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="2.6" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M6 9.3v5.4M18 9.3v5.4"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
